import script from "./DemoCelebrationV3.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemoCelebrationV3.vue?vue&type=script&setup=true&lang=ts"

import "./DemoCelebrationV3.vue?vue&type=style&index=0&id=483e779a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-483e779a"]])

export default __exports__